import { ConsumerApp2 } from "@theatticusapp/atticus-shared-components";
export const ATTICUS_PAGE_PREFIX = "Atticus";
export const REST_API = "protectedREST";
export const PUBLIC_REST_API = "publicREST";
export const LOGGER_NAME = "atticus-app";
export const SCREEN_PATHS = {
  auth: "/auth",
  signOut: "/sign-out",
  app: "/app",
  flow: "/flow",
  onBoarding: "/flow/on-boarding",
  financialConvo: "/flow/financial-convo",
  createAccountAndRedirect: "/app/account-creation",
  home: "/app/home",  // on app2 this is right, for app1 use /home
  probatePacket: "/app/files/probate-packet",
  files: "/app/files",
  forms: "/app/forms-and-files",
  packetForms: "/app/packet/forms-and-files",
  probate: "/app/forms-and-files/probate",
  probateReview: "/app/forms-and-files/probate/review",
  probateAssemble: "/app/forms-and-files/probate/assemble", // animation
  probateConfirm: "/app/forms-and-files/probate/confirm",
  leadProbate: "/lead-probate",
  leadProbateReview: "/lead-probate/review",
  leadProbateAssemble: "/lead-probate/assemble",
  leadMigration: "/lead-migration",
  leadProbateConfirm: "/auth",
  not_found: "/404",
  maintenance: "/maintenance",
};
export const DISABLED_PATHS = [SCREEN_PATHS.home];
export const EXCLUDE_PATH_PAGE_VIEW = [
  SCREEN_PATHS.home,
  SCREEN_PATHS.auth,
  SCREEN_PATHS.forms,
  SCREEN_PATHS.files,
];
export const PROBATE_IDS = {
  someHeirsAreMinors: "some_heirs_are_minors",
  relationshipToDeceased: "relationship_to_deceased",
}
export const DEFAULT_IMAGE_THUMBNAIL_SRC = "https://images.ctfassets.net/6ld2tyyifwli/2aMXNeXcVBqnoC28lF3SCb/004ed123057ec0b75fe618b0df8b7f6b/download_1.png";
// TODO: reference from atticus-shared-components
export const COOKIES = {
  authToken: "AtticusAuth",
  impersonationCookieName: "acting_as",
};
export const STORAGE = {
  invite: "AtticusInvite",
  signUpSuccess: "AtticusSignUp",
  browserBypass: "AtticusOldBrowserBypass",
  envOverride: "AtticusLaravelHost",
  fieldsAnswered: "AtticusFieldsAnswered",
  firstFreeFormId: "AtticusFirstFreeFormId",
  formInterest: "AtticusFormInterest",
};
const laravelHostOverride = window.localStorage.getItem(STORAGE.envOverride);
if (laravelHostOverride)
  console.warn("*** LARAVEL HOST OVERRIDE ***", laravelHostOverride);
export const isProd = `${window.location.protocol}//${window.location.hostname}` === ConsumerApp2.prod;
export const isLocal = window.document.location.host?.includes("localhost");
export const LARAVEL_APP_HOST = isProd ? "https://app.weareatticus.com" : "https://app-preprod1.weareatticus.com"
export const ADVISOR_APP_HOST = isProd ? "https://advisor.weareatticus.com" : "https://advisor-ppd1.weareatticus.com"
export const LARAVEL_APP_API = process?.env?.REACT_APP_LARAVEL_API || "/api"
export const LARAVEL_APP_VERSION = process?.env?.REACT_APP_LARAVEL_API_VERSION || "/v2";
export const LARAVEL_APP_UPGRADE = "/home?show_upgrade=true";
export const FORMS_APP_HOST = process?.env?.REACT_APP_FORMS_HOST || "https://forms.weareatticus.com";
export const isLead = window.location.hostname.indexOf("lead-probate") !== -1
export const PAGE_CONTENT_WIDTH = 820;
export type ButtonColors =
  | "inherit"
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "info"
  | "warning";
export const OUTCOMES = {
  complete: "complete",
  back: "back",
};
export const PASSWORD_EXAMPLE = "P4ssw*rd";
export const PASSWORD_REQUIREMENT_MESSAGE = `Your password must include at least one number, upper, and lower case and as well as a special character. It must be at least 8 characters in length. Example: ${PASSWORD_EXAMPLE}`;
export const SIGN_IN_LONG_MSG_DELAY_SECONDS = 3;
export const AUTH_ERRORS = {
  cognitoNotAuthed: "The user is not authenticated",
  laravelNoData: "could not determine users role and/or group",
  getUserFailed: "getUser failed",
  accountCreation: "account creation failed",
  inviteRedemption: "invite redemption failed",
  signOut: "error signing out",
};
export const UPGRADE_REQUIRED = {
  maxForms:
    "You've exceeded your maximum free forms.  Upgrade for access to all forms.",
};
export const suffixes = [
  "Jr.",
  "Sr.",
  "2nd",
  "3rd",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "Esq.",
  "CPA",
  "DC",
  "DDS",
  "VM",
  "JD",
  "MD",
  "PhD",
];
export const GOOGLE_MAPS_API_KEY = "AIzaSyAndnSaR2dOGnNV6jcNjSuuEKNNwxwBRiQ";
// documentation: https://github.com/TheAtticusApp/atticus-app/wiki/Maintenance-mode
// managed via the amplify console: https://us-east-2.console.aws.amazon.com/amplify/home?code=8ce6e3121bb03545563d&region=us-east-2#/d1p54f4s5pmqh/settings/variables
export const MAINTENANCE_ENABLED =
  process.env.REACT_APP_ENV_MAINTENANCE_ENABLED === "true";
export const PUBLIC_FORMS_CDN_URL = isProd
  ? "https://forms-cdn.weareatticus.com"
  : "https://atticus-forms-dev-public.s3.us-east-2.amazonaws.com";
export const SUPPORT_EMAIL =
  process?.env?.REACT_APP_SUPPORT_EMAIL || "support@weareatticus.com";
export const IMAGE_UPLOAD_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/png",
];
export const USER_DOC_UPLOAD_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/png",
  "application/pdf",
  "application/doc",
  // "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //.docx
];
export const MAX_UPLOAD_BYTES = 5000000; //~5MB
export const MAX_FORMS_FOR_UNPAID = 3;
export enum StateLabel {
  "US" = "State",
  "Canada" = "Province/Territory",
}
export const REGEX = {
  // https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
  phone: new RegExp(
    /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
  ),
  // https://regexr.com/51a26
  password: new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-“!@#%&/,><’:;|_~`])\S{8,99}$/
  ),
};

export const ATTICUS_CONSUMER_APP_HOST = !isProd
  ? "https://app-ppd1.weareatticus.com"
  : "https://app2.weareatticus.com";
export const ATTICUS_CONSUMER_APP_HOST_ORIGINAL = !isProd
  ? "https://app-preprod1.weareatticus.com"
  : "https://app.weareatticus.com";
export const ATTICUS_CONSUMER_APP_REGISTER = `${ATTICUS_CONSUMER_APP_HOST}/auth?signup=true`;

export const META_ROBOTS_VALUE =
  process.env.REACT_APP_META_ROBOTS_VALUE || "all";

export const KNOWLEDGE_FILLED_FORM_GENERATOR_URL = isProd
  ? "https://knowledge-filled-form-generator.weareatticus.com"
  : "https://knowledge-filled-form-generator-ppd1.weareatticus.com";


// if (window) {
//   (window as any).LOG_LEVEL = 'DEBUG'; //Enable if you have issues with cognito auth and need to debug
// }